import React, { Component } from 'react';
import RecordRTC from '../../RecordRTC';
import { Mutation } from 'react-apollo';
import { InMemoryCache } from 'apollo-cache-inmemory';
import { createUploadLink } from 'apollo-upload-client';
import { ApolloClient } from "apollo-client";
import { ApolloProvider } from "react-apollo";
import { gql } from 'apollo-boost';
import AddonText from './addons/addon-text.component';
import AddonImage from './addons/addon-img.component';
import AddonSidebar from './addons/addon-sidebar.component';
import Flag from './addons/addon-flag.component'

// styles and icons
import { Row, Col } from 'react-bootstrap';
import AlbumIcon from '@material-ui/icons/Album';
import StopIcon from '@material-ui/icons/Stop';
import Loader from '../loader/loader.component';
import './video-recorder.style.css';
// import flag from '../../../images/flag.png';

// this component represents the video recorder frame of the create and edit visume page

export default class VideoRecorder extends Component {

    constructor(props) {
        super(props);
        this.state = {
            textAddonsInputs : [],
            imageAddonsInputs : []
        }
    }
    // call back function to get data from child to parent
    callback = (dataFromChild, status) => {
        if (status === "add") {
            if (dataFromChild.text) {
                this.setState({ ...this.state, textAddonsInputs:  [...this.state.textAddonsInputs , dataFromChild], viewText: null, viewImg: null, startTime: 0 })
            }
            else {
                this.setState({ ...this.state, imageAddonsInputs: [...this.state.imageAddonsInputs , dataFromChild], viewText: null, viewImg: null, startTime: 0 })
            }
            this.hideAddonsBtns();
        }
        else if (status === "delete") {
            this.handelDelete(dataFromChild);
            this.hideAddonsBtns();
        }
        else if (status === "view") {
            // set flag
            let flagBtn = document.querySelector('#FlagBtn').classList;
            let video = document.querySelector('video');
            
            flagBtn.add("bg-orange");
            video.pause();

            // show addons
            this.showAddonsBtns();
            // set data
            if (dataFromChild.text) {
                this.setState({ ...this.state, viewText: dataFromChild, viewImg: '', startTime: dataFromChild.start_time })
            }
            else {
                this.setState({ ...this.state, viewImg: dataFromChild, viewText: '' ,  startTime: dataFromChild[0].start_time })
            }
        }
        else if (status === "edit") {
            if (dataFromChild.text) {
                // delete the previouse variable 
                this.handelDelete(this.state.viewText);
                // add the new value
                this.setState({ ...this.state, textAddonsInputs: [...this.state.textAddonsInputs , dataFromChild], viewText: null })
            }
            else {
                console.log(this.state.viewImg)
                if(this.state.viewImg[0].id){
                     dataFromChild[0].id = this.state.viewImg[0].id
                }
                // delete the previouse variable 
                this.handelDelete(this.state.viewImg);
                this.setState({ ...this.state, imageAddonsInputs:[...this.state.imageAddonsInputs , dataFromChild], viewImg: null })
            }
            this.hideAddonsBtns();
        }
        else if (status === "flag") {
            this.setState({ ...this.state, startTime: dataFromChild });
            this.showAddonsBtns();
        } 
        else if (status === "remove flag") {
            this.setState({ ...this.state, viewText: null, viewImg: null })
            this.hideAddonsBtns();
        }
        else if (status === "reset all"){
            this.setState({ ...this.state, imageAddonsInputs : [] ,textAddonsInputs: [], viewText: null, viewImg: null, startTime: 0 })
        }
    }
    showAddonsBtns = () =>{
        document.querySelector('.addonTextAndImage').classList.remove('d-none');
    }
    hideAddonsBtns = ()=>{
        document.querySelector('.addonTextAndImage').classList.add('d-none');
    }
    handelDelete = (item) => {
        let imgAddonsTemp = this.state.imageAddonsInputs;
        let textAddonsTemp = this.state.textAddonsInputs;

        if (item.text) {
            textAddonsTemp.splice(textAddonsTemp.indexOf(item), 1);
        } else {
            imgAddonsTemp.splice(imgAddonsTemp.indexOf(item), 1);
        }

        this.setState({ ...this.state, textAddonsInputs: textAddonsTemp, imageAddonsInputs: imgAddonsTemp, viewImg: '', viewText: ''});
    }
    componentWillReceiveProps(props) {
        console.log(props);
        if (props !== this.props) {
            let tempImgAddon = [] , tempTextAddon = [];
            if(props.data){
                if(props.data.video){
                    if(props.data.video.imageAddons){
                        let handelImage ;
                            props.data.video.imageAddons.forEach(element => {
                                let arry = [];
                                handelImage = element;
                                delete handelImage.created_at;
                                delete handelImage.updated_at;
                                delete handelImage.video_id;
                                delete handelImage.link
                                handelImage.file = handelImage.url;
                                arry.push(handelImage);
                                tempImgAddon.push(arry)
                            });
                        }
                    if(props.data.video.textAddons){
                        let handelText;
                        props.data.video.textAddons.forEach(element => {
                            handelText = element;
                            delete handelText.id;
                            delete handelText.created_at;
                            delete handelText.updated_at;
                            delete handelText.video_id;
                            tempTextAddon.push(handelText)
                        });
                    }   
                }
            }
            this.setState({ ...this.state, bioId: props.data.id, data: props.data , textAddonsInputs: tempTextAddon , imageAddonsInputs : tempImgAddon});

            // set video src if found 
            if (props.data) {
                let video = document.querySelector('video');
                if (props.data.video) {
                    video.setAttribute("src", props.data.video.url);
                    this.showFlag();
                } else {
                    this.hideFlag();
                    video.removeAttribute("src");
                    video.load();
                }
            }
        }
    }
    componentDidMount() {
        let video = document.querySelector('video');
        let recordCards = document.querySelectorAll('.record-card');
        let dateStarted;
        let that = this;
        let timeLimit;
        // open camera
        function captureCamera(callback) {
            navigator.mediaDevices.getUserMedia({ audio: true, video: true }).then(function (camera) {
                callback(camera);
            }).catch(function (error) {
                alert('Unable to capture your camera. Please check console logs.');
                console.error(error);
            });
        }
        //calculate duration time
        function calculateTimeDuration(secs) {
            var hr = Math.floor(secs / 3600);
            var min = Math.floor((secs - (hr * 3600)) / 60);
            var sec = Math.floor(secs - (hr * 3600) - (min * 60));
        
            if (min < 10) {
                min = "0" + min;
            }
        
            if (sec < 10) {
                sec = "0" + sec;
            }
        
            if(hr <= 0) {
                return min + ':' + sec;
            }
        
            return hr + ':' + min + ':' + sec;
        }
        // stop recording function
        function stopRecordingCallback() {
            // clear duration text
            document.querySelector('.duration-time').innerHTML = '';

            // to fix video seeking issues
            RecordRTC.getSeekableBlob(recorder.getBlob(), function (seekableBlob) {
                video.src = URL.createObjectURL(seekableBlob);
            });

            video.src = video.srcObject = null;
            video.controls = true;
            video.muted = false;
            video.volume = 1;
            video.src = URL.createObjectURL(recorder.getBlob());

            // convert blob to file
            let file = new File([recorder.getBlob()], "videoname", {
                type: "video/webm",
            });
            that.setState({ ...this.state, file: file })
            if (that.state.file) {
                document.getElementById("btn-save-video").click();
            }
            recorder.camera.stop();
            recorder.destroy();
            recorder = null;
            window.clearTimeout(timeLimit);
        }
        var recorder; // globally accessible
        // start recording button on click
        document.getElementById('btn-start-recording').onclick = function () {

            // count down from 3 to 1 before starting recording
            let running = false;
            document.querySelector('#counter-container').classList.add('d-none');
                if(!running){
                    running = true;
                    document.querySelector('#counter').innerHTML = 3;
                   document.querySelector('#counter-container').classList.remove('d-none');
                    setTimeout(function() {
                        document.querySelector('#counter').innerHTML = 2;
                    },1000);
                    setTimeout(function() {
                        document.querySelector('#counter').innerHTML = 1;
                    },2000);
                    setTimeout(function() {
                        document.querySelector('#counter').innerHTML = 'Start';
                    },3000)
                    setTimeout(function() {
                        document.querySelector('#counter-container').classList.add('d-none');
                        // after finish countiing down start recording

                        // hide flag btn while recording
                        that.hideFlag();

                        this.disabled = true;
                        video.autoplay = true;
                        video.controls = false;
                        captureCamera(function (camera) {
                            video.muted = true;
                            video.volume = 0;
                            video.srcObject = camera;

                            recorder = RecordRTC(camera, {
                                type: 'video',
                                canvas: {
                                    width: 320,
                                    height: 220
                                }

                            });

                            recorder.startRecording();
                            dateStarted = new Date().getTime();

                            (function looper() {
                                if(!recorder) {
                                    return;
                                }
                    
                                document.querySelector('.duration-time').innerHTML =  calculateTimeDuration((new Date().getTime() - dateStarted) / 1000);
                    
                                setTimeout(looper, 1000);
                            })();

                            // release camera on stopRecording
                            recorder.camera = camera;

                            document.getElementById('btn-stop-recording').disabled = false;
                            document.getElementById('btn-stop-recording').classList.remove("d-none");
                            document.getElementById('btn-start-recording').classList.add("d-none");
                        });

                        // stop recording after 1 minute
                        timeLimit =  setTimeout(function () {    
                                document.getElementById('btn-stop-recording').disabled = true;
                                document.getElementById('btn-stop-recording').classList.add("d-none");
                                video.autoplay = false;
                                document.getElementById('btn-start-recording').disabled = false;
                                document.getElementById('btn-start-recording').classList.remove("d-none");
                                recorder.stopRecording(stopRecordingCallback);
                        },62000)
                    },4000);
                }
        };
        // stop recording btn on click
        document.getElementById('btn-stop-recording').onclick = function () {
            this.disabled = true;
            video.autoplay = false;
            document.getElementById('btn-start-recording').disabled = false;
            document.getElementById('btn-stop-recording').classList.add("d-none");
            document.getElementById('btn-start-recording').classList.remove("d-none");
            recorder.stopRecording(stopRecordingCallback);
            // show flag btn
            that.showFlag();

        };
        // show flag addon
        this.showFlag();
    }
    showFlag =()=>{
            document.querySelector('.addonFlag').classList.remove('d-none');
    }
    hideFlag =()=>{
            document.querySelector('.addonFlag').classList.add('d-none');
    }
    showCounter = () => {
        let running = false;
        document.querySelector('#counter-container').classList.add('d-none');
        document.querySelector('.btn-record-group').addEventListener("click",function(){
            if(!running){
                running = true;
                document.querySelector('#counter').innerHTML = 3;
               document.querySelector('#counter-container').classList.remove('d-none');
                setTimeout(function() {
                    document.querySelector('#counter').innerHTML = 2;
                },1000);
                setTimeout(function() {
                    document.querySelector('#counter').innerHTML = 1;
                },2000);
                setTimeout(function() {
                    document.querySelector('#counter').innerHTML = 'Start';
                    document.querySelector('#counter-container').classList.add('d-none');
                    return true;
                },3000);
            }
        });
    }
    render() {
        // activate uploading link on the oppollo 
        const apolloCache = new InMemoryCache({
            addTypename: false
        })
        const token = (localStorage.getItem('jwt')) ? JSON.parse(localStorage.getItem('jwt')).BearerTokenResponse.access_token : '';

        const uploadLink = createUploadLink({
            uri: 'https://spreago.black-squares.com/graphql',
            headers: {
                authorization: token ? `Bearer ${token}` : ""
            }
        })
        const client = new ApolloClient({
            cache: apolloCache,
            link: uploadLink
        })
        return (
            <div>
                <ApolloProvider client={client}>
                    <Mutation mutation={UPLOAD_FILE_STREAM}>
                        {(videoUpload, { data, loading }) => {
                            return (
                                <form className="videoContainer" encType={'multipart/form-data'}>
                                    <button
                                        hidden
                                        type="button"
                                        id="btn-save-video"
                                        className="btn-orange"
                                        onClick={() => {
                                            const file = this.state.file;
                                            const id = this.props.data.id;
                                            console.log(id);
                                            console.log(file);
                                            file && videoUpload({
                                                variables: { file: file, question_id: id }
                                            }).then((res, loading) => {
                                                console.log(res)
                                                if (res.data.videoUpload.Status.code) {
                                                    //let uploaded = document.querySelector("[data-uploaded=\"" + id + "\"]");
                                                   // uploaded.classList.remove("d-none");
                                                }
                                            }).catch((err) => this.setState({ ...this.state, ConnectionErorr: "Please try again" }));
                                        }}>save</button>
                                    {loading &&
                                        <Loader  
                                            visible="true" 
                                            text="Your video is being uploaded it may take a few seconds. Don't close this screen"
                                        />
                                    }
                                </form>)
                        }}
                    </Mutation>
                    <div className="">
                        <Row className="m-0 rounded mb-1">
                            <Col md={10} xs={12} className="p-0 shadow">
                                <div className="p-relative video-addons-container ">
                                    <Row style={{zIndex : '22'}} id="counter-container" className="d-none align-items-center justify-content-center w-100 text-white  m-0 h-100 text-center p-absolute">
                                        <Col xs={12} style={{fontSize : '35px'}} id="counter"></Col>
                                    </Row>
                                    <div className="videoCustom-container">
                                        <video 
                                            controls
                                            id="video"  
                                                controlslist="nodownload" 
                                                width="100%" 
                                                style={{ transition: "0.5s" , minHeight: "30rem"}} 
                                                className="border-0 bg-black  border-0">
                                        </video>
                                    </div>
                                    <h5 className="duration-time text-orange p-absolute" style={{top:'1rem' , left :'1rem'}}></h5>
                                    <div className="addonFlag d-none">
                                        <Flag
                                            startTime={this.state.startTime} 
                                            callbackFromParent={this.callback}
                                        />
                                    </div>
                                    <div className="addonTextAndImage d-none">
                                        <AddonText 
                                            startTime={this.state.startTime} 
                                            callbackFromParent={this.callback} 
                                            viewText={this.state.viewText}
                                        />
                                        <AddonImage 
                                            startTime={this.state.startTime} 
                                            callbackFromParent={this.callback} 
                                            viewImg={this.state.viewImg}
                                        />
                                    </div>
                                </div>
                            </Col>
                            <Col md={2} xs={12} className="p-0 shadow">
                                <AddonSidebar 
                                    question = {this.state.data}
                                    callbackFromParent={this.callback}  
                                    textAddons={this.state.textAddonsInputs} 
                                    imgAddons={this.state.imageAddonsInputs}
                                />
                            </Col>
                        </Row>
                        <Row className="justify-content-center m-0" >
                            <Col className="p-0">
                                <div className="m-auto btn-record-group bg-dark pr-3 pl-3">
                                    <button className="border-0 bg-transparent text-white pr-2" id="btn-start-recording">
                                            <div className="d-inline-block mr-1" style={{ borderRadius: "50%", background: "gray", padding: "3px", height: "30px", width: "30px" }}>
                                                <AlbumIcon className="text-red text-center" />
                                            </div>
                                            Start
                                    </button>
                                        <button
                                            className="border-0 bg-transparent text-white pl-2 d-none"
                                            id="btn-stop-recording" disabled>
                                            <div className="d-inline-block mr-1" style={{ borderRadius: "50%", background: "gray", padding: "3px", height: "30px", width: "30px" }}>
                                                <StopIcon className="text-red" />
                                            </div>
                                            Stop
                                    </button>
                                </div>
                            </Col>
                        </Row>
                    </div>

                </ApolloProvider>
            </div>
        )
    }
}

const UPLOAD_FILE_STREAM = gql`
mutation(
    $file        : Upload !
    $question_id : Int    !
) {
    videoUpload (
        Inputs : {
            question:{
                id : $question_id
            }
            videoInputs : {
                file : $file
            }
        }
    ) {
        Status {
            code
            title
            message
            check
        }
        question{
            title
            bio{
                title
            }
            video{
                url
                frame{
                    url
                  }
                type{
                    name
                }
                ImageAddons{
                    data
                    url
                  }
                  TextAddons{
                    data
                }
            }
        }
    }
}
`;
